import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Releases } from "@/components/Releases";
import { PreviewSpotlight } from "@/components/PreviewSpotlight";
import { Playlists } from "@/components/Playlists";
import { Manifesto } from "@/components/Manifesto";
import { Roster } from "@/components/Roster";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { PlayerBar } from "@/components/PlayerBar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [tracks, setTracks] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [artists, setArtists] = useState([]);
  const [activeTrack, setActiveTrack] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    axios.get(`${API}/tracks`).then((r) => setTracks(r.data)).catch(console.error);
    axios.get(`${API}/playlists`).then((r) => setPlaylists(r.data)).catch(console.error);
    axios.get(`${API}/artists`).then((r) => setArtists(r.data)).catch(console.error);
  }, []);

  return (
    <div className="scanlines">
      <Nav />
      <Hero trackCount={tracks.length} />
      <Releases tracks={tracks} activeTrack={activeTrack} onPlay={setActiveTrack} />
      <PreviewSpotlight />
      <Playlists playlists={playlists} />
      <Roster artists={artists} tracks={tracks} />
      <Manifesto />
      <ContactForm api={API} />
      <Footer />
      <PlayerBar track={activeTrack} onClose={() => setActiveTrack(null)} />
    </div>
  );
}
